/* Version: 3.5.149 */
'use client';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import LANG from '../lang.js';
import enCA from './en_CA.js';
import frCA from './fr_CA.js';

var i18n = _defineProperty(_defineProperty({}, LANG.EN_CA, enCA), LANG.FR_CA, frCA);

export { i18n as default };
